// ============================================================
//  MASAMADREAM — Mascot Mood System
//  Fase 5: cambia emoji + mensaje según estado del proceso
// ============================================================

import { PROCESSES } from './data.js';

// Moods: emoji overlay + status text + pulse class
const MOODS = {
  happy: {
    overlay: '😊',
    status:  '¡Todo va bien! 🌱',
    pulse:   'mm-mood--happy',
  },
  behind: {
    overlay: '😴',
    status:  'Tu masa te espera...',
    pulse:   'mm-mood--behind',
  },
  overdue: {
    overlay: '😰',
    status:  '¡Actividad pendiente ahora!',
    pulse:   'mm-mood--overdue',
  },
  complete: {
    overlay: '🥳',
    status:  '¡Día completado! 🎉',
    pulse:   'mm-mood--complete',
  },
  done: {
    overlay: '🏆',
    status:  '¡Proceso completo! ¡Eres un panadero! 🍞',
    pulse:   'mm-mood--done',
  },
  idle: {
    overlay: '😌',
    status:  'Listo para empezar ✨',
    pulse:   'mm-mood--idle',
  },
};

export function getMood(process, store) {
  if (!process) return MOODS.idle;

  const pData     = PROCESSES[process.type];
  const now       = Date.now();
  const start     = new Date(process.startDate).getTime();
  const totalActs = pData?.activities?.length || 1;
  const completed = process.completedIds?.length || 0;

  // All done?
  if (completed >= totalActs) return MOODS.done;

  // Today's activities
  const todayActs = (pData?.activities || []).filter(a => a.day === process.currentDay);
  const todayDone = todayActs.every(a => store.isCompleted(a.id));

  if (todayDone && todayActs.length > 0) return MOODS.complete;

  // Any overdue incomplete activity?
  const overdue = (pData?.activities || []).some(a => {
    const scheduled = start + a.timeOffset * 3600000;
    return scheduled < now && !store.isCompleted(a.id);
  });

  if (overdue) {
    // How overdue? > 2h = behind, just now = overdue
    const mostOverdue = (pData?.activities || [])
      .filter(a => !store.isCompleted(a.id))
      .map(a => ({ ...a, scheduledAt: start + a.timeOffset * 3600000 }))
      .filter(a => a.scheduledAt < now)
      .sort((a, b) => a.scheduledAt - b.scheduledAt)[0];

    const overdueMs = mostOverdue ? now - mostOverdue.scheduledAt : 0;
    return overdueMs > 2 * 3600000 ? MOODS.behind : MOODS.overdue;
  }

  return MOODS.happy;
}

export function applyMood(mood) {
  // Update overlay emoji on dial center and home mascot
  const overlay = document.getElementById('mm-mascot-mood-overlay');
  if (overlay) {
    overlay.textContent = mood.overlay;
    overlay.classList.remove(...Object.values(MOODS).map(m => m.pulse));
    overlay.classList.add(mood.pulse);
  }

  // Update status text
  const statusEl = document.getElementById('mm-mascot-status');
  if (statusEl) statusEl.textContent = mood.status;
}

export function refreshMood(process, store) {
  const mood = getMood(process, store);
  applyMood(mood);
}
